// Snarkdown sets module.exports to a function.
// This is not supported in es6 modules.
const sn = require('snarkdown');
const snarkdown = sn.default || sn;

// DEPRECATED
// See https://sim.amazon.com/issues/AVWeb-851
// And https://w.amazon.com/index.php/ATV/Website/Projects/NodePlatform/Markdown%20deprecation
export const parseMarkdown = (str: string) => {
    return snarkdown(str);
}
